import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';

const renderScoring = (score) => {
  if (!score) return '';
  return `${parseFloat(score) * 100}%`;
};

const CarrierScoring = ({ intl, carrier }) => {
  const t = intl.messages.components.CarrierScoring;

  return (
    <span data-testid="carrierScoring">
      {t.scoring} <b>{renderScoring(carrier.scoring)}</b>
    </span>
  );
};

CarrierScoring.propTypes = {
  carrier: PropTypes.object,
  intl: PropTypes.any,
};

export default injectIntl(CarrierScoring);
